
import {defineComponent} from 'vue'
import BaseTitle from "@/components/UI/BaseTitle.vue";
import BaseContainer from "@/components/UI/Bootstrap/BaseContainer.vue";
import {FormMixin} from "@/components/base/FormMixin";
import {DpModuleEnum} from "@/api/enums/dp-module-enum";
import BasePlaceholderTable from "@/components/UI/Bootstrap/BasePlaceholderTable.vue";
import {NotificationTemplateRestService} from "@/services/rest/master/NotificationTemplateRestService";
import {
  NotificationTemplateOverviewRestDto,
  NotificationTemplateResultsRestDto
} from "@/api/pharma-master-notification-template/models";
import NotificationTemplateOverviewItem
  from "@/components/layouts/notification-template/NotificationTemplateOverviewItem.vue";
import {Storage} from "@/models/facade/Storage";
import {SessionStorageKeyEnum} from "@/models/enum/SessionStorageKeyEnum";
import BaseOffcanvas from "@/components/UI/Bootstrap/Offcanvas/BaseOffcanvas.vue";
import NotificationTemplateDetail from "@/pages/notification-templates/NotificationTemplateDetail.vue";
import GenericFormWrapper from "@/components/base/GenericFormWrapper.vue";

export default defineComponent({
  name: "NotificationTemplateOverview",
  mixins: [FormMixin],
  components: {
    GenericFormWrapper,
    NotificationTemplateDetail,
    BaseOffcanvas,
    NotificationTemplateOverviewItem,
    BasePlaceholderTable,
    BaseContainer,
    BaseTitle,
  },
  data: () => ({
    module: DpModuleEnum.ORDER,
    allModules: [
      {code: DpModuleEnum.ORDER, description: DpModuleEnum.ORDER},
      {code: DpModuleEnum.CPC, description: DpModuleEnum.CPC},
      {code: DpModuleEnum.AUTH, description: DpModuleEnum.AUTH},
      {code: DpModuleEnum.PLAN, description: DpModuleEnum.PLAN}
    ],
    templates: null as NotificationTemplateResultsRestDto | null,
    selectedTemplate: undefined as NotificationTemplateOverviewRestDto | undefined,
    templateSequence: 0 as number,
  }),
  mounted() {
    this.initialize();
  },
  computed: {
  },
  methods: {
    async doInitialize(): Promise<void> {
      this.module = Storage.session.get(SessionStorageKeyEnum.NOTIFICATION_TEMPLATE_MODULE) ?? DpModuleEnum.ORDER;
    },
    async doReload(): Promise<void> {
      this.templates = await NotificationTemplateRestService.getInstance().findNotificationTemplates(this.module);
      Storage.session.set(SessionStorageKeyEnum.NOTIFICATION_TEMPLATE_MODULE, this.module);
    },
    async deleteTemplate(template: NotificationTemplateOverviewRestDto): Promise<void> {
      await this.deleteItemWithKey(template.id);
    },
    openDetail(template: NotificationTemplateOverviewRestDto): void {
      this.selectedTemplate = template;
      this.templateSequence++;
      this.openOffCanvas('notificationTemplateUpdateOffCanvas');
    },
    async doDeleteItemWithKey(_id: string): Promise<void> {
      alert('Not yet implemented');
    },
    async reloadContentAndUpdateSelectedTemplate(): Promise<void> {
      await this.reloadContent();
      if (!this.selectedTemplate) {
        return;
      }
      this.selectedTemplate = this.templates?.results?.find((template: NotificationTemplateOverviewRestDto) => template.id === this.selectedTemplate!.id);
      this.templateSequence++;
    }
  }
})
